// LOTE UX-1 — fonte única das 8 linhas de mix (Papéis · Químicos · ...).
// Reutilizada pelo AmpliarMixModal e por RegistrarAtividade quando a
// oportunidade é de ampliação de mix (tipo="ampliacao_mix" ou cross_selling=true).
export const LINHAS_MIX = [
  "Papéis",
  "Químicos",
  "Sabonetes",
  "Lavanderia",
  "Wipers",
  "Equipamentos",
  "Acessórios",
  "Outros",
];
